/*
 *
 * This File Containes API Functions used in the Project
 *
 */

import axios from "axios";

const apiClient = axios.create({
  // baseURL: "",
  timeout: 60000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

export const ApiService = {
  async getData(url) {
    try {
      const response = await apiClient.get(url);
      return response;
    } catch (err) {
      throw err;
    }
  },

  async postData(url, payload = {}) {
    try {
      const response = await apiClient.post(url, payload);
      return response;
    } catch (err) {
      throw err;
    }
  },
};
